import { ApolloError } from "@apollo/client";

export function isApolloError(e: unknown): e is ApolloError {
  return e instanceof ApolloError;
}
